/**
 * @generated SignedSource<<42133cca91dbf7305b4a158a0ad702fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TitleBlockData$data = {
  readonly content: string;
  readonly " $fragmentType": "TitleBlockData";
};
export type TitleBlockData$key = {
  readonly " $data"?: TitleBlockData$data;
  readonly " $fragmentSpreads": FragmentRefs<"TitleBlockData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleBlockData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "TitleBlock",
  "abstractKey": null
};

(node as any).hash = "5cb35df5119097faec33fe71d189c39f";

export default node;
